import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Original root-site URL — permanently redirect to the /locations child page.
export const Route = createFileRoute("/restore-midwest")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/locations/restore-midwest/", location.searchStr), statusCode: 301 });
  },
});
